import { render } from "./InstallationEvents.vue?vue&type=template&id=595a8969&scoped=true"
import script from "./InstallationEvents.vue?vue&type=script&lang=js"
export * from "./InstallationEvents.vue?vue&type=script&lang=js"

import "./InstallationEvents.vue?vue&type=style&index=0&id=595a8969&scoped=true&lang=css"

import exportComponent from "/home/gbl/SoftwareProjects/MyProjects/UniStuttgart/truscanWebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595a8969"]])

export default __exports__